"use client";

import React from "react";
import { CircleAlert as AlertCircle } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
export default function InflatableBull() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="whatisinflatablemechanicalbull" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="space-y-6">
          <div className="border-b border-border pb-4">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-foreground">
              What Is an Inflatable Mechanical Bull?
            </h2>
          </div>

          <div className="space-y-4 text-base sm:text-lg text-foreground/90 leading-relaxed font-sans">
            <p>
              An inflatable mechanical bull is a powered mechanical bull surrounded by an inflatable safety arena. The bull itself is mechanical; the surrounding landing area is inflatable.
            </p>
            <p>
              That distinction matters when comparing equipment because the powered machine and the inflatable arena are separate components with different setup, condition, maintenance and replacement considerations.
            </p>
            <p>
              A complete package may also include an operator controller, blower, cables and accessories. Package contents vary, so always check the individual listing before comparing prices.
            </p>
          </div>

          <div className="border-l-4 border-primary bg-card p-6 border-y border-r border-border shadow-xs">
            <div className="flex items-start gap-4">
              <AlertCircle className="size-6 text-primary shrink-0 mt-0.5" aria-hidden="true" />
              <div className="space-y-2">
                <h3 className="font-serif text-xl font-bold uppercase tracking-wide text-foreground">
                  Buyer Tip
                </h3>
                <p className="text-sm sm:text-base text-foreground/90 leading-relaxed font-sans">
                  Do not confuse an inflatable mechanical bull with a fully inflatable novelty bull. Confirm that the listing is for an actual powered mechanical bull when that is what you intend to purchase.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}